import BillingComponents from '../../permissions/constants/billingComponents';
import UserPermissions from '../constants/userPermissions';
import { PermissionRules } from '../usePermissions';

type billingComponentRegistry = {
  [name in BillingComponents]: PermissionRules;
};

const BillingComponentRegistry: billingComponentRegistry = {
  Checkout: {
    [UserPermissions.EDIT_BILLING]: true,
  },
  Countdown: {
    [UserPermissions.VIEW_BILLING]: true,
  },
  UpgradeButton: {
    [UserPermissions.EDIT_BILLING]: true,
  },
  CancelSubscriptionButton: {
    [UserPermissions.EDIT_BILLING]: true,
  },
};

export default BillingComponentRegistry;
